module.exports = __webpack_public_path__ + "img/MONEY.a1bbfbdc.svg";